/* Miroir de la liste blanche définie côté backend (app/models/role.rb,
 * validates :name, inclusion: {...}) — à garder synchronisée si de nouveaux
 * rôles sont ajoutés côté Rails. Sert uniquement de suggestions pour la
 * saisie libre du nom de rôle (le backend reste la seule source de vérité :
 * toute valeur hors liste sera rejetée avec une 400 explicite). */
export const KNOWN_ROLE_NAMES: string[] = [
  'admin',
  'action_accept_return_payment',
  'action_booked_b2b',
  'action_booked_marketing',
  'action_cancel_tasks_device_info',
  'action_declare_order_return',
  'action_delete_device',
  'action_delete_failure',
  'action_delete_order_return',
  'action_delete_order_line',
  'action_derogation_qualite',
  'action_finish_purchase_payment',
  'action_finish_purchase_control',
  'action_generate_report',
  'action_match_hs_proposal',
  'action_out_of_stock_proposal',
  'action_print_carrier_label',
  'action_print_unpacking_label',
  'action_reset_carrier_label',
  'action_see_matching_error',
  'action_unlock_purchase_payment',
  'action_unmatch',
  'action_update_order_shipping_date',
  'adv_access',
  'analytics_access',
  'control_control_computer',
  'control_grading',
  'control_management',
  'control_unpacking',
  'control_warranty_nc',
  'management_maj_algo_cost',
  'management_maj_repair_cost',
  'management_maj_invoices',
  'management_mass_status_change',
  'management_batch_stock_withdrawal',
  'management_ship_order',
  'management_uk_computer_transfer',
  'management_uk_invoice_credit_note',
  'matching_deposit',
  'matching_picking',
  'matching_print_label',
  'production_cage_management',
  'production_cleaning',
  'production_key_change',
  'production_packaging',
  'production_management',
  'production_quality_control',
  'production_repair',
  'purchase_order',
  'purchase_reception',
  'purchase_stock',
  'purchase_supplier',
  'sav_rc_access',
  'buyback_access',
  'buyback_achat',
  'buyback_reception',
  'buyback_admin',
  'buyback_control',
  'buyback_expedition',
  'buyback_kypseli',
  'fast_regrading',
  'special_process_eligibility_table',
  'special_process_dismantle',
  'special_process_assemble'
];

/* Libellé lisible généré à partir du code technique (ex. "adv_access" -> "Adv access") */
export function roleLabel(name: string): string {
  if (!name) return '';
  const words = name.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
